import { useNavigate, useLocation } from 'react-router-dom';
import { ChefHat, Users, Carrot } from 'lucide-react';

export const AdminNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const tabs = [
    { label: 'Meals', to: '/admin/meals', icon: ChefHat, match: '/admin/meals' },
    { label: 'Core Foods', to: '/admin/core-foods', icon: Carrot, match: '/admin/core-foods' },
    { label: 'Users & Access', to: '/admin/users', icon: Users, match: '/admin/users' },
  ];
  return (
    <div className="flex items-center gap-2 mb-6" data-testid="admin-nav">
      {tabs.map((t) => {
        const active = location.pathname.startsWith(t.match);
        const Icon = t.icon;
        return (
          <button
            key={t.to}
            onClick={() => navigate(t.to)}
            data-testid={`admin-nav-${t.label.toLowerCase().replace(/[^a-z]+/g, '-')}`}
            className={
              'flex items-center gap-2 px-4 h-10 rounded-full text-sm font-semibold transition-colors ' +
              (active
                ? 'bg-accent text-white shadow-sm'
                : 'bg-secondary text-foreground hover:bg-secondary/80 border border-border/40')
            }
          >
            <Icon size={16} />
            {t.label}
          </button>
        );
      })}
    </div>
  );
};

export default AdminNav;
